/**
 * Mutex asíncrono para JavaScript.
 *
 * Garantiza que solo UNA operación acceda al recurso protegido a la vez,
 * encolando el resto en una cadena de promesas.
 *
 * Uso:
 *   const mutex = createMutex()
 *   await mutex.acquire(() => operacionExclusiva())
 */
export function createMutex () {
  // La "llave": promesa que representa la operación en curso.
  // Inicia resuelta → el recurso está libre.
  let _lock = Promise.resolve()

  return {
    /**
     * Ejecuta `fn` en exclusión mutua.
     * Si otra operación está en curso, espera a que termine antes de entrar.
     *
     * @param {() => Promise<any>} fn - Función async a proteger
     * @returns {Promise<any>} Resultado de fn
     */
    acquire (fn) {
      // Encadeno fn al final de la promesa actual.
      // El catch vacío en _lock asegura que un error en fn
      // no rompa la cadena para las operaciones siguientes.
      const next = _lock.then(() => fn())
      _lock = next.then(() => {}, () => {})
      return next
    }
  }
}
